import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearTokens } from "@vault/cognito-auth";

import UserBadge from "../../components/UserBadge";
import Button from "../../components/Button";
import Popup from "../../components/Popup";
import { useTranslation } from "react-i18next";
import { logOut } from "../auth/authSlice";

const UserMenu = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    clearTokens();
    dispatch(logOut());
    navigate("/login", { replace: true });
  };

  return (
    <div>
      <Popup
        isFixedPosition
        dropdown
        fitContent
        expandBottomLeft
        renderOpen={(onClick) => (
          <UserBadge roundelOnly large onClick={onClick} />
        )}
      >
        <Button dropdownSelector icon={"exit"} onClick={handleLogout}>
          {t("auth.logout")}
        </Button>
      </Popup>
    </div>
  );
};

export default UserMenu;
